// src/components/Logo.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import neoLegalLogo from '../assets/neo-legal-logo.png';
import lexMapleLogo from '../assets/maple-leaf.svg';
import { editionConfig, firmProfile, isNeoLegalFirm } from '../edition';

export default function Logo({ variant = 'default', size = 32, showText = false, brand = 'firm', firmName = firmProfile.legalName }) {
  const colors = {
    default: '#113B5B',
    inverted: '#FFFFFF',
  };
  const color = colors[variant];
  const showFirmBrand = brand === 'firm' && isNeoLegalFirm(firmName);
  const logo = showFirmBrand ? neoLegalLogo : lexMapleLogo;
  const label = showFirmBrand ? 'NEO Legal' : editionConfig.platformName;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', color }}>
      <Box
        component="img"
        src={logo}
        alt={label}
        sx={{
          width: size,
          height: size,
          objectFit: showFirmBrand ? 'cover' : 'contain',
          borderRadius: Math.max(6, size * 0.2),
          bgcolor: '#fff',
        }}
      />
      {showText && (
        <Typography
          variant="h5"
          component="span"
          sx={{
            fontWeight: 700,
            fontSize: size * 0.55,
            letterSpacing: 0.5,
            color,
            ml: 0.5,
            //textShadow: variant === 'inverted' ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
          }}
        >
          {showFirmBrand ? firmProfile.displayName : editionConfig.platformName}
        </Typography>
      )}
    </Box>
  );
}
